module.exports = __webpack_public_path__ + "img/A.167ba872.png";